import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cac593ea&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac593ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cac593ea')) {
      api.createRecord('cac593ea', component.options)
    } else {
      api.reload('cac593ea', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cac593ea&scoped=true&", function () {
      api.rerender('cac593ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MjoHutwhclwN/JS/comp/Accordion.vue"
export default component.exports